import $ from 'jquery';

export default function (params) {
  //'designation',
  var fields = {
    'title': 'contact_title',
    'salute': 'contact_salute',
    'forename': 'contact_forename',
    'surname': 'contact_surname',
    'email': 'contact_email',
    'phone': 'contact_phone',
    'cell': 'contact_cell',
  };

  $('#contacts').on('click', '.copy-ceo-content', function (event) {
    event.preventDefault();
    var targetForm = $(this).parent();

    targetForm.find('[name$="designation"]').val($(this).data('designation'));

    $.each(fields, function(target, source) {
      var sourceField = $('[name="' + source + '"]');
      var targetField = targetForm.find('[name$="' + target + '"]');

      if (sourceField.val()) {
        targetField.val(sourceField.val());
      }
    });
  });
}
